import type { FrontendInfo, PentaErrorData } from '@/interfaces/pentaError.interfaces'

// Puerto a TS de src/utils/PentaError.js, para usarse del lado Vue (throw manual o envoltura de errores de red)
export class PentaError extends Error {
  name: string
  source?: string
  frontendInfo?: FrontendInfo
  _id?: string
  randId?: string
  ts?: string
  _extraInfo?: Record<string, any>

  constructor(code: string | PentaErrorData) {
    super(typeof code === 'string' ? code : code.message)
    if (typeof code === 'object') {
      this._id = code._id
      this.randId = code.randId
      this.ts = code.ts
      this._extraInfo = code._extraInfo
      this.frontendInfo = code.frontendInfo
      this.source = code.source
      this.name = code.name !== 'PentaError' ? 'PentaError GENERIC' : 'PentaError'
      if (code.stack) this.stack = code.stack + '\n' + this.stack
    } else {
      this.source = 'vue'
      this.name = 'PentaError'
    }
  }

  // Agrega metadata extra para el log del error, no se muestra al usuario
  extraInfo(name: string | Record<string, any>, data?: any): this {
    if (!this._extraInfo) this._extraInfo = {}
    if (typeof name === 'object') this._extraInfo[Object.keys(this._extraInfo).length] = name
    else this._extraInfo[name] = data
    return this
  }

  // Configura el modal rico que se muestra al usuario (icon, title, message, actions), ver interfaces/pentaError.interfaces.ts
  setFrontendInfo(name: string | FrontendInfo, data?: any): this {
    if (!this.frontendInfo) this.frontendInfo = {}
    if (typeof name === 'object') Object.assign(this.frontendInfo, name)
    else (this.frontendInfo as any)[name] = data
    return this
  }
}
